import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/kosh-v2/kosh-v2/src/frontend/src/layouts/mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Privacy Policy`}</h1>
    <p>{`Tattle isn't in the business of monetizing data. So, we don't want to collect your data. But, in interacting with Kosh, and other Tattle services, you do share some details that are stored on Tattle servers. We outline them here, all the data you may share with Tattle in interacting with the site:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Email ID for Kosh Login.`}</strong>{`
Kosh is an archive. Its goal is to make visible content that is circulated on Indian social media and messaging apps. The ways in which such an archive may be used or misused isn't always clear. Login details are one way of restricting/removing bad actors from the archive.`}</li>
      <li parentName="ol"><strong parentName="li">{`Password for Kosh Login.`}</strong>{`
An encrypted hash for your password is stored with Tattle. This enables you to recover your password in case you forget it.`}</li>
      <li parentName="ol"><strong parentName="li">{`Website Analytics.`}</strong>{`
Tattle uses `}<a parentName="li" {...{
          "href": "https://plausible.io/"
        }}>{`Plausible Analytics`}</a>{`, a GDPR compliant web analytics tool, that minimizes data collection and does not share data with third parties. We monitor only high level metrics such as the number of unique visitors we get on the site, the total number of pages visited and the high level web source (such as Google search or GitHub) through which visitors discovered the link.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      